<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapState,mapGetters,mapActions } from "vuex"
import Swal from "sweetalert2";
// import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Add Products",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    // ModelListSelect,
  },
  data() {
    return {
      title: "Add Products",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "add Products",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      unitmodal_id: "",
      is_uploading: false,
      existingProduct: [],
      nameError: "",
      unitError: "",
      categoryError: "",
      productError: "",
      sellingPriceError: "",
      UnitProductunitError: "",
      UnitqtyError: "",
      UnitsellingPriceError: "",

      // Value from user input for adding product
      data: {
        name: "",
        product: "",
        category: "",
        color: "",
        code: "",
        minimum: 10,
        selling_price: 0,
        buying_price: 0,
        quantity: 0,
        reserve_price: "",
        vat: 0,
        unit: "Car(s)",
        otherunits: [],
        wholesale_reserveprice: "",
        wholesale_unitprice: "",
      },
      // edit product
      editdata: {
        name: "",
        color: "",
        code: "",
        minimum: 10,
        selling_price: 0,
        reserve_price: "",
        wholesale_unitprice:"",
        wholesale_reserveprice:"",
        vat: 0,
        id: "",
      },
      // delete product
      deletedata: {
        name: "",
        id: "",
      },

    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("products", ["SaveStatus", "BProducts", "Units", "Categories","Products"]),
    ...mapGetters("auth", ["MyUserPerm","business","branch"]),
    ...mapGetters("general", ["Branches"]),
    ...mapGetters("setting", ["GeneralSettings"]),


    /**
     * Total no. of records
     */

    rows() {
      return this.Products ? this.Products.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Products ? this.Products.length : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
          this.closeModal(this.modal_id);
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchBProducts: "products/fetchBProducts",
      FetchProducts: "products/fetchProducts",
      FetchUnits: "products/fetchUnits",
      AddProduct: "products/addProduct",
      FetchCategories: "products/fetchPCategories",
      AddProductUnit: "products/addProductUnit",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingProduct = this.Products.filter((product) => {
          return product.name.toUpperCase() == this.data.name.toUpperCase();
        });
        if (this.existingProduct.length) {
          this.nameError = this.data.name + " exists already";
        } else {
          this.nameError = "";
        }
      } else {
        this.existingProduct = [];
      }
    },

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    addSellCommas(){
        this.data.selling_price = this.thousandSeperator(this.data.selling_price);
    },
    addReserveCommas(){
        this.data.reserve_price = this.thousandSeperator(this.data.reserve_price);
    },

    addProduct(modalId) {
      this.modal_id = modalId;
      if (this.data.category === "") {
        this.categoryError = "Category field is required";
        return;
      } else {
        this.categoryError = "";
      }
      if (this.data.name === "") {
        this.nameError = "Product name field is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.existingProduct.length) {
        this.nameError = this.data.name + " exists already please";
        return;
      } else {
        this.nameError = "";
      }

      this.AddProduct(this.data);
    },

    resetAdd() {
      this.data.name = "";
      this.data.product = "";
      this.data.category = "";
      this.data.color = "";
      this.data.code = "";
      this.data.minimum = 10;
      this.data.selling_price = 0;
      this.data.buying_price = "";
      this.data.quantity = 0;
      this.data.reserve_price = "";
      this.data.wholesale_reserveprice = "";
      this.data.wholesale_unitprice = "";
      this.data.vat = 0;
      this.data.unit = "Cars(s)";
      this.data.otherunits = [];      
      this.modal_id = "";
      this.unitmodal_id = "";

    },
    resetEdit() {
      this.editdata.name = "";
      this.editdata.color = "";
      this.editdata.code = "";
      this.editdata.minimum = 10;
      this.editdata.selling_price = 0;
      this.editdata.wholesale_unitprice = "";
      this.editdata.wholesale_reserveprice = "";
      this.editdata.vat = 0;
      this.editdata.id = "";
      this.modal_id = "";
    },


    resetError() {
      this.nameError = "";
      this.categoryError = "";
      this.productError = "";
      this.sellingPriceError = "";
    },
    redirect(value) {
      this.$router.push(
        `/stock/movement/${btoa(value)}`
      );
    },
    //== close modal
    closeModal(modalId) {
        this.resetError();
        this.resetAdd();
        this.resetEdit();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    assignName(){
        this.data.name = this.data.product;

        if (this.data.product != "") {
          let ProductData = this.Products.filter((product) => {
            return product.business_product.name.toUpperCase() == this.data.product.toUpperCase();
          });
          if (ProductData.length) {
            this.data.code = ProductData[0].code;
          }else{
            this.data.code = '';
          }
        }else{
          this.data.code = '';
        }
    },

  },
  created() {
    this.FetchBProducts();
    this.FetchProducts();
    this.FetchUnits();
    this.FetchCategories();
    this.FetchGeneralSettings();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="card">
        <div class="card-body">
            <div class="row px-5">
              <div class="col-md-6">
                <div class="form-group mb-3">
                    <label>Select Business Category <span class="text-danger">*</span></label>
                    <input
                    class="form-control"
                    v-model="data.category"
                    list="categories"
                    placeholder="Select Business Category"
                    @input="resetError()"
                    />
                    <datalist id="categories">
                    <option
                        v-for="(cat, c) in Categories"
                        :data-value="cat.catName"
                        :key="c"
                    >
                        {{ cat.catName }}
                    </option>
                    </datalist>
                    <div class="text-danger" v-if="categoryError">
                    <em>{{ categoryError }}</em>
                    </div>
                </div>
                </div>

                <div class="col-md-6">
                    <div class="form-group mb-3">
                    <label>Product Name<span class="text-danger">*</span></label>
                    <input
                    class="form-control"
                    v-model="data.product"
                    placeholder="Choose Product"
                    type="text"
                    @input="resetError()"
                    @blur="checkName(), assignName()"
                    autocomplete="off"
                    />
                    <div class="text-danger" v-if="productError">
                    <em>{{ productError }}</em>
                    </div>
                </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group mb-3">
                        <label>Colour</label>
                        <div class="input-group">
                        <input
                            type="text"
                            placeholder="Enter Product Colour"
                            class="form-control"
                            @keyup="checkName()"
                            v-model="data.color"
                        />
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group mb-3">
                        <label>Chassis Number </label>
                        <div class="input-group">
                        <input
                            type="text"
                            placeholder="Enter Chassis number"
                            class="form-control"
                            v-model="data.code"
                        />
                        </div>
                    </div>
            
                </div>
                <div class="col-md-6" v-if="GeneralSettings.enable_wholeselling == 1">
                    <div class="form-group mb-3">
                        <label>Wholesale Price</label>
                        <div class="input-group">
                        <input
                            type="text"
                            placeholder="Enter Product Unit Selling Price"
                            class="form-control"
                            v-model="data.wholesale_unitprice"
                        />
                        </div>
                    </div>
            
                </div>
                
                <div class="row">
                <div v-if="GeneralSettings.allow_reserve_price == 1" class="col-md-6">
                  <div class="form-group mb-3">
                      <label>Reserve Price</label>
                      <div class="input-group">
                      <input
                          type="text"
                          placeholder="Enter Reserve Price"
                          class="form-control"
                          v-model="data.reserve_price"
                          @input="addReserveCommas()"
                      />
                      </div>
                    </div>
            
                </div>
                <div class="col-md-6" v-if="GeneralSettings.enable_wholeselling == 1 && GeneralSettings.allow_reserve_price == 1">
                    <div class="form-group mb-3">
                        <label>Wholesale reserve Price</label>
                        <div class="input-group">
                        <input
                            type="text"
                            placeholder="Enter Reserve Price"
                            class="form-control"
                            v-model="data.wholesale_reserveprice"
                        />
                        </div>
                    </div>
            
                </div>
                </div>
                <div class="mb-3" align="right">
                    <button
                    type="button"
                    class="btn btn-primary"
                    @click="addProduct('add-product-modal')"
                    > <i class="fa fa-check"></i>
                    Submit
                    <b-spinner
                        v-if="SaveStatus"
                        variant="light"
                        small
                        label="Spinning"
                    ></b-spinner>
                    </button>
                </div>  

            </div>
        </div>
    </div>
     
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>   
